export default __webpack_public_path__ + "static/media/back_ic.b20c7b0c.svg";